import { lazy, Suspense } from "react";

import { Skeleton } from "@/components/ui/skeleton";

// The contact page ships in the entry chunk; the gallery usage card and its
// model load on demand so they never count against the entry bundle budget.
const ContactGalleryUsage = lazy(() =>
  import("./ContactGalleryUsage").then((module) => ({
    default: module.ContactGalleryUsage,
  })),
);

export const LazyContactGalleryUsage = ({
  contactId,
}: {
  contactId: string | number;
}) => (
  <Suspense fallback={<Skeleton className="h-5 w-32" aria-busy="true" />}>
    <ContactGalleryUsage contactId={contactId} />
  </Suspense>
);
